import apiClient from './client';

export interface KeyMetrics {
  /** The instant both order windows are measured back from. */
  asOf: string;
  windowDays: number;
  lenders: { count: number };
  orders: { count: number; previousCount: number };
  /** Loans created in each window, meaning the loans whose first order falls in it. Optional so the
   *  card simply stays out if this UI is deployed ahead of the backend that serves it. */
  loans?: { count: number; previousCount: number };
}

export async function getKeyMetrics(): Promise<KeyMetrics> {
  const response = await apiClient.get('/oms/dashboard/metrics');
  return response.data;
}
